import { transformFromBackendAction, transformToBackendAction } from "./transformers/action-transformer";
import {transformFromBackendAlertCaseRecord, transformToBackendAlertCaseRecord} from "./transformers/alertcase-record-transformer";
import { transformFromBackendAlert as transformFromBackendAlertCase, transformToBackendAlert as transformToBackendAlertCase } from "./transformers/alertcase-transformer";
import { transformFromBackendCapture, transformToBackendCapture } from "./transformers/capture-transformer";
import { transformFromBackendConsolidateByEventIds, transformToBackendConsolidateByEventIds } from "./transformers/consolidate-by-event-ids";
import { transformFromBackendConsolidateEvent, transformToBackendConsolidateEvent } from "./transformers/consolidate-event-transformer";
import { transformFromBackendDatamodelAssociation, transformToBackendDatamodelAssociation } from "./transformers/datamodel-association-transformer";
import { transformFromBackendDatamodelReportConfiguration, transformToBackendDatamodelReportConfiguration } from "./transformers/datamodel-report-configuration-transformer";
import { transformFromBackendDatamodelReportFiltering, transformToBackendDatamodelReportFiltering } from "./transformers/datamodel-report-filtering-transformer";
import { transformFromBackendDatamodelReport, transformToBackendDatamodelReport } from "./transformers/datamodel-report-transformer";
import {transformToBackendEventRowData, transformFromBackendDatamodelRowData} from "./transformers/datamodel-row-data-transformer";
import { transformFromBackendDatamodelTable, transformToBackendDatamodelTable } from "./transformers/datamodel-table-transformer";
import { transformFromBackendDataset, transformToBackendDataset } from "./transformers/dataset-transformer";
import { transformFromBackend, transformToBackend} from "./transformers/default-transformer";
import { transformFromBackendDocument, transformToBackendDocument } from "./transformers/document-transformer";
import { transformFromBackendDomainProcessType, transformToBackendDomainProcessType } from "./transformers/domain-process-type-transformer";
import { transformFromBackendDomainType, transformToBackendDomainType } from "./transformers/domain-type-transformer";
import { transformFromBackendEntity, transformToBackendEntity } from "./transformers/entity-transformer";
import { transformFromBackendEnumeration, transformToBackendEnumeration } from "./transformers/enumeration-transformer";
import { transformFromBackendEvent, transformToBackendEvent } from "./transformers/event-transformer";
import { transformFromBackendEventConsolidationInfo, transformToBackendEventConsolidationInfo } from "./transformers/eventConsolidation-transformer";
import { exportReportFromBackend, exportReportToBackend } from "./transformers/export-report-transformer";
import { transformFromBackendGetAlertcasesByEvent, transformToBackendGetAlertcasesByEvent } from "./transformers/get-alertcases-by-event-transformer";
import { transformFromBackendLayout } from "./transformers/layout-template-transfrormer";
import { transformFromBackendLinkTableUpdate, transformToBackendLinkTableUpdate } from "./transformers/link-table-update-transformer";
import { transformFromBackendManagerConfig, transformToBackendManagerConfig } from "./transformers/manager-config";
import { transformFromBackendNote, transformToBackendNote } from "./transformers/note-transformer";
import { transformFromBackendProcessType, transformToBackendProcessType } from "./transformers/process-type-transformer";
import { transformFromBackendRelatedEntity, transformToBackendRelatedEntity } from "./transformers/related-entity-transformer";
import { transformFromBackendReport } from "./transformers/report-transformer";
import { transformFromBackendScreen, transformToBackendScreen } from "./transformers/screen-transformer";
import { transformFromBackendTemplateLayout, transformToBackendTemplateLayout } from "./transformers/template-layout-transformer";
import { transformToBackendTenant, transformFromBackendTenant } from "./transformers/tenant-transformer";
import { transformFromBackendUserGroup, transformToBackendUserGroup} from "./transformers/user-group-transformer";
import { transformFromBackendWidget } from "./transformers/widget-transformer";
import {transformFromBackendReferencingComponents, transformToBackendReferencingComponents} from "./transformers/referencing-components-transformer"; 
import { transformFromBackendHistory, transformToBackendHistory } from "./transformers/history-transformer";
import { transformFromBackendCustomSearchFields, transformToBackendCustomSearchFields } from "./transformers/custom-search-transformer";
import { transformFromBackendAdvancedSearchFields, transformToBackendAdvancedSearchFields } from "./transformers/advanced-search-transformer";
import {transformFromBackendEntityWithReferenceTransformer} from "./transformers/entity-with-reference-fields-transformer";
import {transformFromBackendTranslationList, transformToBackendTranslationList} from "./transformers/translation-list-transformer";

export type TransformTypes = "enumeration" | "entity" | "alertcase" | "action" | "event" | "dataset" | "databaseConnection" | 
                              "trigger" | "modelStatus" | "layout" | "archived" | "datasetLabels" | "tenant" | "report" | "widget" | 
                              "pdf" | "model" | "token" | "Fileform" | "domainProcessType" | "templateLayout" | "capture" | "alertcaseRecord" | 
                              "datamodelTable" | "datamodelRowData" | "screen" | "note" | "document" | "datamodelAssociation" | 
                              "eventConsolidationInfo" | "consolidateEvent" | "relatedEntity" |  "userGroup" | "managerConfig" | "datamodelReport" | 
                              "datamodelReportConfiguration" | "processType" | "domainType" | "datamodelReportFiltering" | "exportReport" | 
                              "linkTableUpdate" | "getAlertcasesByEvent" | "consolidateByEventIds"| "referencingComponents" | "history" | "advancedSearchConfig" | "advancedSearch" | "entityWithReference" | "translationList" | "default";

export function getFromTransformer(type: TransformTypes): any { // eslint-disable-line
  switch (type) {
    case "enumeration":
      return transformFromBackendEnumeration;
    case "entity":
      return transformFromBackendEntity;
    case "alertcase":
      return transformFromBackendAlertCase;
    case "action":
      return transformFromBackendAction;
    case "event":
      return transformFromBackendEvent;
    case "dataset":
      return transformFromBackendDataset;
    case "databaseConnection":
      return transformFromBackend;
    case "trigger":
      return transformFromBackend;
    case "modelStatus":
      return transformFromBackend;
    case "layout":
      return transformFromBackendLayout;
    case "archived":
      return transformFromBackend;
    case "datasetLabels":
      return transformFromBackend;
    case "tenant":
      return transformFromBackendTenant;
    case "report":
      return transformFromBackendReport;
    case "widget":
      return transformFromBackendWidget;
    case "pdf":
      return transformFromBackend;
    case "model":
      return transformFromBackend;
    case "token":
      return transformFromBackend;
    case "Fileform":
      return transformFromBackend;
    case "domainProcessType":
      return transformFromBackendDomainProcessType;
    case "templateLayout":
      return transformFromBackendTemplateLayout;
    case "capture":
      return transformFromBackendCapture;
    case "alertcaseRecord":
      return transformFromBackendAlertCaseRecord;
    case "datamodelTable":
      return transformFromBackendDatamodelTable;
    case "datamodelRowData":
      return transformFromBackendDatamodelRowData;
    case "screen":
      return transformFromBackendScreen;
    case "note":
      return transformFromBackendNote;
    case "document":
      return transformFromBackendDocument;
    case "datamodelAssociation":
      return transformFromBackendDatamodelAssociation;
    case "eventConsolidationInfo":
      return transformFromBackendEventConsolidationInfo;
    case "consolidateEvent":
      return transformFromBackendConsolidateEvent;
    case "relatedEntity":
      return transformFromBackendRelatedEntity;
    case "userGroup":
      return transformFromBackendUserGroup;
    case "managerConfig":
      return transformFromBackendManagerConfig;
    case "datamodelReport":
      return transformFromBackendDatamodelReport;
    case "datamodelReportConfiguration":
      return transformFromBackendDatamodelReportConfiguration;
    case "processType":
      return transformFromBackendProcessType;
    case "domainType":
      return transformFromBackendDomainType;
    case "datamodelReportFiltering":
      return transformFromBackendDatamodelReportFiltering;
    case "exportReport":
      return exportReportFromBackend;
    case "linkTableUpdate":
      return transformFromBackendLinkTableUpdate;
    case "getAlertcasesByEvent":
      return transformFromBackendGetAlertcasesByEvent;
    case "consolidateByEventIds":
      return transformFromBackendConsolidateByEventIds;
    case "history":
      return transformFromBackendHistory;
    case "advancedSearchConfig":
      return transformFromBackendCustomSearchFields;
    case "advancedSearch":
      return transformFromBackendAdvancedSearchFields;
    case "referencingComponents":
      return transformFromBackendReferencingComponents;
    case "entityWithReference":
      return transformFromBackendEntityWithReferenceTransformer;
    case "translationList":
      return transformFromBackendTranslationList;
    case "default":
      return transformFromBackend;
    default:
      return transformFromBackend;
  }
}

export function getToTransformer(type: TransformTypes): any { // eslint-disable-line
  switch (type) {
    case "enumeration":
      return transformToBackendEnumeration;
    case "entity":
      return transformToBackendEntity;
    case "alertcase":
      return transformToBackendAlertCase;
    case "action":
      return transformToBackendAction;
    case "event":
      return transformToBackendEvent;
    case "dataset":
      return transformToBackendDataset;    
    case "databaseConnection":
      return transformToBackend;
    case "trigger":
      return transformToBackend;
    case "modelStatus":
      return transformToBackend;
    case "layout":
      return transformToBackend;
    case "archived":
      return transformToBackend;
    case "datasetLabels":
      throw Error("DatasetLabels post is not supported");
    case "tenant":
      return transformToBackendTenant;
    case "report":
      return transformToBackend;
    case "widget":
      return transformToBackend;
    case "pdf":
      return transformToBackend;
    case "model":
      return transformToBackend;
    case "token":
      return transformToBackend;
    case "Fileform":
      return transformToBackend;
    case "domainProcessType":
      return transformToBackendDomainProcessType;
    case "templateLayout":
      return transformToBackendTemplateLayout;
    case "capture":
      return transformToBackendCapture;
    case "alertcaseRecord":
      return transformToBackendAlertCaseRecord;
    case "datamodelTable":
      return transformToBackendDatamodelTable;
    case "datamodelRowData":
      return transformToBackendEventRowData;
    case "screen":
      return transformToBackendScreen;
    case "note":
      return transformToBackendNote;
    case "document":
      return transformToBackendDocument;
    case "datamodelAssociation":
      return transformToBackendDatamodelAssociation;
    case "eventConsolidationInfo":
      return transformToBackendEventConsolidationInfo;
    case "consolidateEvent":
      return transformToBackendConsolidateEvent;
    case "relatedEntity":
      return transformToBackendRelatedEntity;
    case "userGroup":
      return transformToBackendUserGroup;
    case "managerConfig":
      return transformToBackendManagerConfig;
    case "datamodelReport":
      return transformToBackendDatamodelReport;
    case "datamodelReportConfiguration":
      return transformToBackendDatamodelReportConfiguration;
    case "processType":
      return transformToBackendProcessType;
    case "domainType":
      return transformToBackendDomainType;
    case "datamodelReportFiltering":
      return transformToBackendDatamodelReportFiltering;
    case "exportReport":
      return exportReportToBackend;
    case "linkTableUpdate":
      return transformToBackendLinkTableUpdate;
    case "getAlertcasesByEvent":
      return transformToBackendGetAlertcasesByEvent;
    case "consolidateByEventIds":
      return transformToBackendConsolidateByEventIds;
    case "history":
      return transformToBackendHistory;
    case "advancedSearchConfig":
      return transformToBackendCustomSearchFields;
    case "advancedSearch":
      return transformToBackendAdvancedSearchFields;
    case "referencingComponents":
      return transformToBackendReferencingComponents;
    case "translationList":
      return transformToBackendTranslationList;
    case "default":
      return transformToBackend;
    default:
      return transformToBackend;

    // Removed case for referencing components as the module does not exist
  }
}